import { render, staticRenderFns } from "./NavbarSide.vue?vue&type=template&id=4b832441"
import script from "./NavbarSide.vue?vue&type=script&lang=js"
export * from "./NavbarSide.vue?vue&type=script&lang=js"
import style0 from "./NavbarSide.vue?vue&type=style&index=0&id=4b832441&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports